<template>
  <div style="margin: 0 auto;width: 100%;">
    <Header/>
    <PlayerDetail/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import PlayerDetail from './components/PlayerDetail'
import Footer from './components/Footer'
export default {
  components: {
    Header,
    PlayerDetail,
    Footer
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/ProgramPlayerDetail.vue